import { z } from 'zod';

export const optionalTextField = (max: number) => z.string().trim().max(max);

export const nullWhenEmpty = (value: string): string | null => (value === '' ? null : value);
